"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavDrawer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = require("../..");

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

require("@zebra-fed/icons/Navigation/index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    width: ", ";\n    background: white;\n    position: fixed;\n    left: ", ";\n    visibility: ", ";\n    top: 0;\n    bottom: 0;\n    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    outline: none;\n    z-index: ", ";\n    box-shadow: ", "; \n    cursor: default;  \n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    position: fixed;    \n    top: 0;\n    right: ", ";\n    left: 0;\n    bottom: 0;\n    opacity: ", ";\n    transition: opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    background: rgba(0,0,0,.5);\n    z-index: ", ";\n    cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalContainer = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.open ? 0 : '100vw';
}, function (props) {
  return props.open ? 1 : 0;
}, function (props) {
  return props.spacing.menuZIndex;
});

var NavWrapper = _styledComponents["default"].section(_templateObject2(), function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.width;
}, function (props) {
  return props.open ? '0px' : 'calc(-' + props.width + ' - 10px)';
}, function (props) {
  return props.open ? 'visible' : 'hidden';
}, function (props) {
  return props.spacing.menuZIndex + 1;
}, function (props) {
  return props.open ? '0 0 20px rgba(0,0,0,.5)' : '0 0 0 rgba(0,0,0,0)';
});
/**
 * The Nav Drawer component is a container that wraps a collection of elements in a hidden module. 
 * By default, the icon to trigger the opening and closing of the LeftNav panel is rendered in the place that the component is inserted in the DOM.
 * Available functions via refs:
 * - toggle()
 * - open()
 * - close()
 * - isOpen(): returns boolean.
 * @example import { NavDrawer } from '@desktop/react';
 */


var NavDrawer = (0, _react.forwardRef)(function (props, ref) {
  var type = 'default';
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[type];

  var _useState = (0, _react.useState)(props.open),
      _useState2 = _slicedToArray(_useState, 2),
      opened = _useState2[0],
      setOpen = _useState2[1];

  var NavDrawer = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    toggleMenu(opened);

    if (opened) {
      NavDrawer.current.focus();
    }
  }, [opened]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      toggle: toggle,
      open: open,
      close: close,
      isOpen: isOpen
    };
  });

  var toggleMenu = function toggleMenu(opened) {
    if (NavDrawer) {
      setOpen(opened !== undefined ? opened : !opened);
    }
  };

  var toggleOnBlur = function toggleOnBlur(e) {
    e.preventDefault();
    e.stopPropagation();

    if (props.closeOnBlur && NavDrawer) {
      setTimeout(function () {
        var target = document.activeElement;
        var isNested = NavDrawer ? NavDrawer.current.contains(target) : null;

        if (!isNested) {
          toggleMenu(null, false);
          props.onBlur();
        }
      }, 150);
    }
  };

  function close() {
    toggleMenu(null, false);
  }

  function open() {
    toggleMenu(null, true);
  }

  function toggle() {
    toggleMenu();
  }

  function isOpen() {
    return opened;
  }

  var navNODE = /*#__PURE__*/_react["default"].createElement(NavWrapper, {
    open: opened,
    spacing: spacing,
    width: props.width,
    className: props.className,
    style: props.style,
    fontFamilyObj: context.getFont(),
    tabIndex: "1",
    ref: NavDrawer,
    key: "navmenu",
    onBlur: toggleOnBlur
  }, props.children);

  var renderedNODE = props.modal ? [/*#__PURE__*/_react["default"].createElement(ModalContainer, {
    key: "modalcontainer",
    open: opened,
    spacing: spacing,
    onClick: toggleOnBlur
  }), navNODE] : navNODE;

  var iconStyle = _objectSpread({
    cursor: 'pointer'
  }, props.iconstyle);

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: iconStyle
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    color: props.color,
    category: 'navigation',
    name: 'hamburger-menu',
    size: 24,
    onClick: toggleMenu
  }), renderedNODE);
});
exports.NavDrawer = NavDrawer;
NavDrawer.propTypes = {
  /**The content displayed in the nav drawer. */
  children: _propTypes["default"].node,

  /**A boolean that will change the open and close state of the menu. */
  open: _propTypes["default"].bool,

  /**Adds a darkened background around the menu to represent focus on the launched menu. */
  modal: _propTypes["default"].bool,

  /**Extends the base styling of the nav drawer. */
  style: _propTypes["default"].object,

  /**A CSS color value for the icon used as a trigger for the left nav. */
  color: _propTypes["default"].string,

  /**REVISIT THIS */
  icon: _propTypes["default"].string,

  /**A CSS width property used to set the width of the menu that slides out. */
  width: _propTypes["default"].string,

  /**REVISIT THIS */
  iconstyle: _propTypes["default"].object,

  /**This will automatically clsoe the menu when the user clicks off of it. */
  closeOnBlur: _propTypes["default"].bool,

  /**This callback function will fire when the menu is blurred. */
  onBlur: _propTypes["default"].func
};
NavDrawer.defaultProps = {
  style: {},
  modal: false,
  color: 'black',
  icon: 'menu',
  width: '250px',
  iconstyle: {},
  closeOnBlur: true,
  onBlur: function onBlur() {
    return false;
  },
  open: false
};